/**
 * Homepage / floating drop resume: `{ file, s3Key }` after a successful S3 upload,
 * or `{ file }` when S3 failed and the flow fell back to the legacy in-memory file.
 */

const BYTES_PER_MB = 1024 * 1024;
export const MAX_DROP_RESUME_BYTES = 2 * BYTES_PER_MB;

export function getDropResumeFile(userResume) {
  if (!userResume) return null;
  if (userResume.file instanceof File || userResume.file instanceof Blob) {
    return userResume.file;
  }
  if (userResume instanceof File || userResume instanceof Blob) {
    return userResume;
  }
  return null;
}

export function getDropResumeS3Key(userResume) {
  return userResume?.s3Key ?? null;
}

export function getDropResumeDisplayName(userResume) {
  return getDropResumeFile(userResume)?.name ?? "";
}
